import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.customerInsuranceName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerInsuranceName", $$v);
      },
      expression: "form.customerInsuranceName"
    }
  })], 1), _c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("产品标识")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品标识"),
      allowClear: ""
    },
    model: {
      value: _vm.form.insuranceMark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceMark", $$v);
      },
      expression: "form.insuranceMark"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("审核状态")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("审核状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("审核中")))]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v(_vm._s(_vm.$t("审核通过")))]), _c("a-select-option", {
    attrs: {
      value: 4
    }
  }, [_vm._v(_vm._s(_vm.$t("已驳回")))])], 1)], 1), _c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("发布应用")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("发布应用"),
      allowClear: "",
      "filter-option": _vm.filterOption,
      "show-search": "",
      "option-filter-prop": "children"
    },
    model: {
      value: _vm.form.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "applicationId", $$v);
      },
      expression: "form.applicationId"
    }
  }, _vm._l(_vm.applicationList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.applicationId
      }
    }, [_vm._v(" " + _vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ") ")]);
  }), 1)], 1), _c("a-form-item", [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))])], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "reviewNodeId"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "statusName",
      fn: function (text, record) {
        return [_c("div", {
          style: record.status == 4 ? "color:red" : ""
        }, [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [record.status == 2 ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerLine",
                params: {
                  id: record.reviewNodeId,
                  type: 1
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("审核")))]) : _vm._e(), record.status != 2 ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerLine",
                params: {
                  id: record.reviewNodeId,
                  type: -1
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看详情")))]) : _vm._e(), _c("a-button", {
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleSee(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("审核进度")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.processShow ? _c("process-model", {
    ref: "processFrom",
    on: {
      cancel: function ($event) {
        _vm.processShow = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };